import { Stack, TextField } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { MAX_URL_LENGTH } from '../../constants';
import { CMSAssetWarning } from './CMSAssetWarning';

interface CMSNewLinkAssetModalTabProps {
  urlValue: string;
  setUrlValue: (url: string) => void;
  warningMessage: string;
  isUploadingLink: boolean;
}

export const CMSNewLinkAssetModalTab = ({
  urlValue,
  setUrlValue,
  warningMessage,
  isUploadingLink,
}: CMSNewLinkAssetModalTabProps) => {
  const TRANSLATED_URL_LABEL = I18n.t('js.admin.cms.url_label');
  const TRANSLATED_URL_DESCRIPTION = I18n.t('js.admin.cms.url_description');

  return (
    <Stack size={2}>
      <TextField
        data-testid="url-textfield"
        description={TRANSLATED_URL_DESCRIPTION}
        label={TRANSLATED_URL_LABEL}
        isDisabled={isUploadingLink}
        placeholder="https://url.com"
        value={urlValue}
        onChange={(value) => {
          setUrlValue(value);
        }}
        maxLength={MAX_URL_LENGTH}
      />
      {warningMessage && <CMSAssetWarning warningMessage={warningMessage} />}
    </Stack>
  );
};
